import React from 'react';
import { Info, X } from 'lucide-react';

const ROLES = [
  "Admin",
  "Designer",
  "Accountant",
  "Store Incharge",
  "Field Marketing",
  "Client Coordinator",
  "Social Media",
];

export const RoleGuideButton = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="relative" id="role-info-btn-wrap">
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        className={`w-9 h-9 rounded-md border flex items-center justify-center transition-all shadow-sm ${
          open
            ? 'bg-slate-800 border-slate-800 text-white'
            : 'bg-white border-slate-200 hover:border-slate-800 text-slate-600 hover:text-slate-900'
        }`}
        title="View roles"
      >
        <Info size={15} />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-[9998]" onClick={() => setOpen(false)} />
          <div className="fixed right-6 top-[190px] z-[9999] w-[200px] bg-white border border-slate-200 rounded-xl shadow-xl overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-3 py-2.5 bg-slate-900">
              <span className="text-[10px] font-bold text-white uppercase tracking-widest leading-tight">
                Roles Avaliable in<br />Verve Kitchens
              </span>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="w-5 h-5 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all"
              >
                <X className="w-3 h-3 text-white" />
              </button>
            </div>
            {/* Role list */}
            <div className="py-1.5">
              {ROLES.map((name) => (
                <div key={name} className="flex items-center gap-2.5 px-3 py-2 hover:bg-slate-50 transition-colors">
                  <span className="w-1.5 h-1.5 rounded-full bg-slate-400 flex-shrink-0" />
                  <span className="text-[12px] font-medium text-slate-700">{name}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
